/* Soulyshine product page runtime (material slider behaviour, PDP scroll stability, material selection). Loaded deferred, first among the product scripts. */
/* ---- soulyshine-material-slider-v3-behavior ---- */
(function () {
    // Material picker slider. v3: one scroll per selection, keeps the shopper's
    // scroll offset when product scripts re-render the picker, and measures with
    // getBoundingClientRect (offsetLeft is relative to a different ancestor).
    var containerSelector = '.main-product-section .product-form__input--material-fallback';
    var memory = {};
    var refreshQueued = false;
    var resizeTimer;

    function getItems(scroller) {
      return Array.prototype.filter.call(scroller.children, function (child) {
        return child.matches('label[data-option-value], .color-swatch');
      });
    }

    function buildFallbackTrack(container) {
      var appTrack = container.querySelector(':scope > .color-swatches-container');
      var track = container.querySelector(':scope > .ss-material-slider-track');
      if (appTrack || track) return appTrack || track;

      var inputs = Array.prototype.slice.call(
        container.querySelectorAll(':scope > input[type="radio"][name="Material"]')
      );
      if (!inputs.length) return null;

      track = document.createElement('div');
      track.className = 'ss-material-slider-track';
      var heading = container.querySelector(':scope > .product-form__label-container');
      if (heading) {
        heading.insertAdjacentElement('afterend', track);
      } else {
        container.insertBefore(track, inputs[0]);
      }

      inputs.forEach(function (input) {
        var label = container.querySelector('label[for="' + input.id + '"]');
        track.appendChild(input);
        if (label) track.appendChild(label);
      });

      return track;
    }

    function keyOf(container) {
      var section = container.closest('.shopify-section, section');
      return (section && section.id) || 'main';
    }

    function prepare(container) {
      var scroller = buildFallbackTrack(container);
      if (!scroller) {
        scroller = container.querySelector(':scope > .color-swatches-container');
      }
      if (!scroller) return null;

      var count = getItems(scroller).length;
      container.classList.toggle('ss-material-fit-mobile', count >= 5);
      container.classList.toggle('ss-material-fit-desktop', count >= 5);
      container.classList.toggle('ss-material-overflow-mobile', count > 5);
      container.classList.toggle('ss-material-overflow-desktop', count > 6);

      if (!scroller.__ssMaterialBound) {
        scroller.__ssMaterialBound = true;
        scroller.addEventListener('scroll', function () {
          memory[keyOf(container)] = scroller.scrollLeft;
        }, { passive: true });
      }
      return scroller;
    }

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setLeft(scroller, left, smooth) {
      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      left = Math.max(0, Math.min(max, Math.round(left)));
      if (Math.abs(scroller.scrollLeft - left) < 1) return;
      if (smooth && !reducedMotion()) {
        scroller.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        var previous = scroller.style.scrollBehavior;
        scroller.style.scrollBehavior = 'auto';
        scroller.scrollLeft = left;
        scroller.style.scrollBehavior = previous;
      }
    }

    function selectedItem(container, scroller) {
      var input = container.querySelector('input[type="radio"][name="Material"]:checked');
      if (!input) return null;
      return input.closest('.color-swatch') || scroller.querySelector('label[for="' + input.id + '"]');
    }

    // Scroll only when the chosen card is cut off, and only as far as needed.
    function revealSelected(container, smooth) {
      var scroller = prepare(container);
      if (!scroller) return;
      var item = selectedItem(container, scroller);
      if (!item) return;
      var box = scroller.getBoundingClientRect();
      var card = item.getBoundingClientRect();
      if (!box.width || !card.width) return;
      if (card.left < box.left - 1) {
        setLeft(scroller, scroller.scrollLeft + (card.left - box.left), smooth);
      } else if (card.right > box.right + 1) {
        setLeft(scroller, scroller.scrollLeft + (card.right - box.right), smooth);
      }
    }

    // Runs once per track element: first load, or after a product script swapped the picker.
    function settle(container) {
      var scroller = prepare(container);
      if (!scroller || scroller.__ssMaterialSettled) return;
      scroller.__ssMaterialSettled = true;
      var saved = memory[keyOf(container)];
      if (typeof saved === 'number') setLeft(scroller, saved, false);
      revealSelected(container, false);
    }

    function refresh() {
      document.querySelectorAll(containerSelector).forEach(settle);
    }

    function queueRefresh() {
      if (refreshQueued) return;
      refreshQueued = true;
      window.requestAnimationFrame(function () {
        refreshQueued = false;
        refresh();
      });
    }

    function needsBuild() {
      return !!document.querySelector(containerSelector + ' > input[type="radio"][name="Material"]');
    }

    function start() {
      refresh();
      var main = document.getElementById('MainContent') || document.body;
      new MutationObserver(function () {
        // Wrap a freshly rendered picker before it is painted unwrapped.
        if (needsBuild()) refresh();
        else queueRefresh();
      }).observe(main, { childList: true, subtree: true });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches(containerSelector + ' input[type="radio"][name="Material"]')) return;
      var container = input.closest('.product-form__input--material-fallback');
      if (container) revealSelected(container, true);
    }, true);

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        document.querySelectorAll(containerSelector).forEach(function (container) {
          revealSelected(container, false);
        });
      }, 120);
    });

    document.addEventListener('soulyshine:variant:updated', queueRefresh);
    document.addEventListener('shopify:section:load', queueRefresh);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

/* ---- soulyshine-pdp-scroll-stability ---- */
(function () {
    // Keeps the option a shopper just tapped at the same spot on screen while the
    // product info re-renders (price, Shop Pay terms, full picker swaps). Safari has
    // no native scroll anchoring, so without this the page jumps after each choice.
    var INFO = '.product__info-container';
    var anchor = null;
    var pinUntil = 0;
    var frame = 0;
    var termsHeight = 0;

    function esc(value) {
      return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
    }

    function labelFor(input) {
      return (input.id && document.querySelector('label[for="' + esc(input.id) + '"]')) || input.closest('label') || input;
    }

    function finderFor(control) {
      var name = control.name;
      if (!name) return null;
      if (control.matches('input[type="radio"], input[type="checkbox"]')) {
        var value = control.value;
        return function () {
          var inputs = document.querySelectorAll(INFO + ' input[name="' + esc(name) + '"]');
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === value) return labelFor(inputs[i]);
          }
          return null;
        };
      }
      if (control.matches('select')) {
        return function () { return document.querySelector(INFO + ' select[name="' + esc(name) + '"]'); };
      }
      return null;
    }

    function topOf(el) {
      var box = el && el.isConnected ? el.getBoundingClientRect() : null;
      return box && (box.width || box.height) ? box.top : null;
    }

    function release() {
      anchor = null;
      pinUntil = 0;
    }

    function jumpBy(delta) {
      var root = document.documentElement;
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(window.pageXOffset, window.pageYOffset + delta);
      root.style.scrollBehavior = previous;
    }

    function correct() {
      if (!anchor || Date.now() > anchor.until) return;
      var el = anchor.el && anchor.el.isConnected ? anchor.el : anchor.find();
      if (!el) return;
      anchor.el = el;
      var top = topOf(el);
      if (top === null) return;
      var delta = top - anchor.top;
      if (Math.abs(delta) < 1) return;
      anchor.corrections += 1;
      if (anchor.corrections > 40) {
        release();
        return;
      }
      jumpBy(delta);
      var after = topOf(el);
      // Sticky columns (desktop) or page edges don't follow the page scroll:
      // if scrolling didn't bring the option back, stop instead of chasing it.
      if (after === null || Math.abs(after - anchor.top) > Math.abs(delta) - 0.5) release();
    }

    function pin(ms) {
      pinUntil = Math.max(pinUntil, Date.now() + ms);
      if (frame) return;
      var step = function () {
        frame = 0;
        if (!anchor || Date.now() > pinUntil) return;
        correct();
        frame = window.requestAnimationFrame(step);
      };
      frame = window.requestAnimationFrame(step);
    }

    document.addEventListener('change', function (event) {
      var control = event.target;
      if (!event.isTrusted || !control || !control.closest) return;
      if (!control.closest(INFO) || !control.closest('variant-selects, .product-form__input, [class*="breed-picker"]')) return;
      var find = finderFor(control);
      if (!find) return;
      var el = find() || labelFor(control);
      var top = topOf(el);
      if (top === null) return;
      anchor = { find: find, el: el, top: top, until: Date.now() + 8000, corrections: 0 };
      pin(1800);
    }, true);

    // A real scroll gesture from the shopper always wins.
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('touchmove', release, { passive: true });
    window.addEventListener('keydown', function (event) {
      if (/^(PageUp|PageDown|Home|End|ArrowUp|ArrowDown| )$/.test(event.key) && !(event.target.closest && event.target.closest('input, select, textarea'))) release();
    });

    function rememberTerms() {
      var form = document.querySelector(INFO + ' form.installment');
      var h = form ? form.getBoundingClientRect().height : 0;
      if (h > 0) termsHeight = h;
    }

    function onSwap() {
      // Shop Pay terms render asynchronously and start at 0px; hold their space.
      var form = document.querySelector(INFO + ' form.installment');
      if (form && termsHeight && form.getBoundingClientRect().height < termsHeight) {
        form.style.minHeight = termsHeight + 'px';
      }
      if (anchor) {
        correct();
        pin(1500);
      }
    }

    function watch() {
      rememberTerms();
      document.querySelectorAll('.product__info-wrapper').forEach(function (wrapper) {
        if (wrapper.__ssStabilityObserved) return;
        wrapper.__ssStabilityObserved = true;
        new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            if (records[i].addedNodes.length) {
              onSwap();
              return;
            }
          }
        }).observe(wrapper, { childList: true });
      });
      if (window.ResizeObserver) {
        var form = document.querySelector(INFO + ' form.installment');
        if (form && !form.__ssTermsObserved) {
          form.__ssTermsObserved = true;
          new ResizeObserver(rememberTerms).observe(form);
        }
      }
    }

    document.addEventListener('soulyshine:variant:updated', function () {
      onSwap();
      watch();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch, { once: true });
    } else {
      watch();
    }
    window.addEventListener('load', rememberTerms, { once: true });
  })();

/* ---- soulyshine-material-selection-v3 ---- */
(function () {
    var containerSelector = '.main-product-section .product-form__input--material-fallback';
    var syncQueued = false;

    function syncContainer(container) {
      if (!container) return;
      var input = container.querySelector('input[type="radio"][name="Material"]:checked');
      var heading = container.querySelector('.product-form__label-container .form__label');
      if (!input || !heading) return;
      var text = 'Material: ' + input.value;
      if (heading.textContent.trim() !== text) heading.textContent = text;
      heading.setAttribute('title', text);
    }

    function syncAll() {
      document.querySelectorAll(containerSelector).forEach(syncContainer);
    }

    function queueSync() {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncAll();
      });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches(containerSelector + ' input[type="radio"][name="Material"]')) return;
      syncContainer(input.closest('.product-form__input--material-fallback'));
    }, true);

    document.addEventListener('shopify:section:load', queueSync);

    function start() {
      syncAll();
      var picker = document.querySelector('variant-selects');
      if (picker) {
        new MutationObserver(queueSync).observe(picker, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
